module.exports = __webpack_public_path__ + "img/product-1-back-INTMOBILE.9acd6ff1.png";